import { useEffect, useState } from "react";
import { api, StudentError } from "../studentClient.js";
import FileRow from "../../components/FileRow.js";

interface WelcomeFile { name: string; s3Key: string; sizeBytes: number; }

export default function WelcomePage() {
  const [files, setFiles] = useState<WelcomeFile[]>([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api<{ files: WelcomeFile[] }>("/student/welcome")
      .then((d) => setFiles(d.files))
      .catch((e) => setError(e instanceof StudentError ? e.message : "Failed to load materials"))
      .finally(() => setLoading(false));
  }, []);

  async function download(key: string) {
    // Open the tab synchronously inside the tap so iOS Safari doesn't block it as
    // a popup (window.open after an await loses the user-gesture context), then
    // redirect it to the presigned URL. Fall back to the same tab if blocked.
    const win = window.open("", "_blank");
    try {
      const { url } = await api<{ url: string }>(`/student/welcome/download-url?key=${encodeURIComponent(key)}`);
      if (win) win.location.href = url;
      else window.location.href = url;
    } catch (e) {
      if (win) win.close();
      setError(e instanceof StudentError ? e.message : "Download failed");
    }
  }

  if (loading) return <p className="subhead">Loading...</p>;

  return (
    <>
      <section className="wel-hero">
        <span className="wel-kicker">Your starting kit</span>
        <h1>Welcome to Mizpah</h1>
        <p>Everything you need to begin - your student handbook, required health forms, and course textbook. Download them anytime; they're always here.</p>
      </section>

      {error && <div className="login-err" style={{ marginBottom: 14 }}>{error}</div>}

      {files.length === 0 ? (
        <div className="hw-blank"><div className="hw-blank-mark">✦</div><p>No welcome materials available yet.</p></div>
      ) : (
        <div className="wel-card">
          <div className="hw-lbl" style={{ marginTop: 0 }}>Welcome materials</div>
          <div className="hw-files">
            {files.map((f, idx) => (
              <div key={f.s3Key} className="wel-reveal" style={{ animationDelay: `${idx * 70}ms` }}>
                <FileRow name={f.name} sizeBytes={f.sizeBytes} onClick={() => download(f.s3Key)} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
